<!-- =========================================================================================
  File Name: FullPage.vue
  Description: Full page layout
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--full-page">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  methods: {
    updateTheme() {
      this.$setColors();
    },
  },
  created() {
    this.$setSchoolTheme();
    // this.$store.dispatch("updateSchoolTheme", "digi");
    this.updateTheme();
  }
};
</script>